import { Component, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from 'src/app/core/interceptors/loader/loader.service';
import { AzureBlobStorageService } from 'src/app/core/services/azure-blob-storage/azure-blob-storage.service';
import { InstanceService } from 'src/app/core/services/instance-management/instance.service';
import { InstanceManagement } from 'src/app/shared/enum/instance-management';
import { DatePipe, Location } from '@angular/common';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { Sort } from '@angular/material/sort';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
@Component({
  selector: 'app-view-application-logs',
  templateUrl: './view-application-logs.component.html',
  styleUrls: ['./view-application-logs.component.scss']
})
export class ViewApplicationLogsComponent implements OnInit{
  @ViewChild('levelData') levelData!: MatSelect;
  @ViewChild('sourceData') sourceData!: MatSelect;
  @ViewChild('search_input') inputName: any;
  breadCrumbItems:any = [];
  public instanceEnum = InstanceManagement;
  instanceData: any = {
    title: 'Instance Details',
    records: [],
  };
  instanceId: any;
  filterElementsValue: any;
  appLogFile: any;
  response: any;
  tableApplicationLogs: any;
  tableNewApplicationLogs: any;
  displayedColumnsNewApplicationLogs: any = ['Level','TimeStamp','ActivitySourceName', 'Action'];
  dataSourceValuesNewApplicationLogs: any = {
    Level: {
      label: 'Level',
      data: 'Level',
    },
    TimeStamp:{
      label: 'Time Stamp',
      data: 'Timestamp'
    },
    ActivitySourceName: {
      label: 'Source',
      data: 'Message?.ProcessName',
    },
    Message: {
      label: 'Message',
      data: 'Name',
    },
    EventName: {
      label: 'Event Name',
      data: 'EventName',
    },
    TenantCode: {
      label: 'Tenant Code',
      data: 'TenantCode',
    },
    Action: {
      label: 'Action',
      data: '',
    },
  };
  currentPage: any;
  pageLength: any;
  pageSize: any = 10;
  dataSourceNewApplicationLogs: any = {
    matchingCount:0,
    records: [ ],
  };
  searchTerm:string= '';
  getContextUserId: string = "";
  getContextInstanceEntityName: string = "";
  getContextInstanceId: string = "";  
  levelList:any = ['All','Information','Error','Warning','Fatal','Verbose'];
  sourceList:any = ['All','TaskService','API','UI'];
  disableClearFilter:any = '';
  showIcon: any = false;
  advanceFilter: boolean = false;
  enableOldAppLogs: boolean = false;
  totaldata: any = [];
  pageSizeNewApplicationLogs: any = 10;
  currentPageNewApplicationLogs: any = 0;
  pageNumberNewApplicationLogs: any = 0;

  /////
  getdate = new Date();
  OnInitendDate = new Date();
  startDateError: boolean = false;
  startDateErrorMsg: string = "";
  endDateError: boolean = false;
  endDateErrorMsg: string = "";
  getStartValueappLog: any;
  getEndValueappLog : any;
  validateConfirmAction: boolean = true;
  minAppStartDate: any;
  maxAppStartDate: any;
  startDate = new Date();
  endDate = new Date();
  maxAppEndDate: any;
  setApplicationMinEndDate = new Date();
  getSearchValueappLog: string = "";
  //selectedLogType: any;
  selectedLevel: any;
  getTraceId: string = "";
  initialData: any;
  ViewData: any = [];
  filteredData: any =[];
  emptyFieldRegex = /<(.|\n)*?>/g;
  sortBy: any;
  /////

  constructor(
    private instanceService: InstanceService,
    private blobService: AzureBlobStorageService,
    private loader: LoaderService,
    private location: Location,
    private datePipe: DatePipe,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private router: Router,
  ){

  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Home', path: 'resources' },
      { label: 'Instance Operations', path: 'instanceoperations/instance-requests' },
      { label: 'Instances', path: 'instanceoperations/instance-requests' },
      { label: 'Instance Tools',path: 'instanceoperations/instance-requests/instance-tools-landing'},
      { label: 'Instance Tools History', path: 'instanceoperations/instance-requests/history' },
      { label: 'Application logs', path: 'history/view-applogs' },
    ];
    this.instanceId = localStorage.getItem('instanceID');
    this.getInstanceByID()
    
    this.getdate.setDate(this.getdate.getDate() - 1);
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.minAppStartDate = this.startDate.toISOString().substring(0,16);
    this.maxAppStartDate = this.endDate.toISOString().substring(0,16);
    this.maxAppEndDate = this.transformDate(this.endDate);
    this.setApplicationMinEndDate = this.minAppStartDate;
    let localData:any = localStorage.getItem('appLogFileDetails');
    if(localData){
      this.filterElementsValue = JSON.parse(localData).filterElementsValue;
      this.appLogFile = JSON.parse(localData).fileName;
      this.getStartValueappLog = JSON.parse(localData)?.requestedFrom;
      this.getEndValueappLog =  JSON.parse(localData)?.requestedTo;
      this.getSearchValueappLog = this.filterElementsValue;
      // this.selectedLogType = JSON.parse(localData).logType;
      // if(this.selectedLogType == 1){
      //   this.displayedColumnsNewApplicationLogs = ['TimeStamp','ActivitySourceName', 'Action'];
      // }
    }
    
    this.downloadLogs();
  }

  getInstanceByID() {
    try {
      this.instanceService
        .getInstanceByID(this.instanceId)
        .subscribe((resp: any) => {
          let result = resp.body;
          if (result != undefined && result != null) {
            this.ViewData = result;         
          }
        });
    } catch (error) {
      console.log(error);
    }
  }
  
  enableAdvanceFilter(){
    this.advanceFilter = !this.advanceFilter
    let localData:any = localStorage.getItem('appLogFileDetails');
    if(localData){
      this.filterElementsValue = JSON.parse(localData).filterElementsValue;
      this.appLogFile = JSON.parse(localData).fileName;
      this.getStartValueappLog = JSON.parse(localData)?.requestedFrom;
      this.getEndValueappLog =  JSON.parse(localData)?.requestedTo;
      this.getSearchValueappLog = this.filterElementsValue;
      this.selectedLevel = JSON.parse(localData).level,
     // this.selectedLogType = JSON.parse(localData).logType,
      this.getTraceId = JSON.parse(localData).traceId,
      this.getContextUserId = JSON.parse(localData).contextUserId,
      this.getContextInstanceEntityName = JSON.parse(localData).ContextInstanceEntityName,
      this.getContextInstanceId = JSON.parse(localData).ContextInstanceId,
      this.getSearchValueappLog = JSON.parse(localData).searchText
      this.initialData = {
        startDate:  JSON.parse(localData)?.requestedFrom,
        endDate:JSON.parse(localData)?.requestedTo
      }
    }
    let instanceVersionCompare = this.ViewData.iciVersion?.localeCompare(
      '8.7.3.0',
      undefined,
      { numeric: true, sensitivity: 'base' }
    );
    if(instanceVersionCompare < 0) {
      this.enableOldAppLogs = true;
    }
    else {
      this.enableOldAppLogs = false;
    }
  }
  clearFilter(){
    if(this.levelData){
      this.levelData.value = '';
    }
    if(this.sourceData){
      this.sourceData.value = '';
    }
    this.clearInput();
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(data: any) {
    let sortState: Sort = data?.event;
    if (sortState.direction == 'desc') {
      this.sortBy = sortState.active + '_' + sortState.direction;
    } else {
      if(sortState.direction){
        this.sortBy = sortState.active;
      } else {
        this.sortBy = '';
      }
      
    }
    this.getNewApplicationLogs(this.currentPageNewApplicationLogs,this.pageSizeNewApplicationLogs)
  }

  sortData(sortBy:any){
    if(sortBy.includes('TimeStamp')){
      if (sortBy.includes('_desc')) {
        let sortData = sortBy.split('_')[0];
        this.filteredData?.sort((a: any, b: any) => {
          const dateA = new Date(a.Timestamp).getTime(); // Convert to timestamp (number)
          const dateB = new Date(b.Timestamp).getTime(); // Convert to timestamp (number)
          return dateB - dateA;  // Compare dates in descending order
          
        });
      } else {
        let sortData = sortBy;
        
        this.filteredData?.sort((a: any, b: any) => {
          const dateA = new Date(a.Timestamp).getTime(); // Convert to timestamp (number)
          const dateB = new Date(b.Timestamp).getTime(); // Convert to timestamp (number)
          return dateA - dateB;  // Compare dates in ascending order
        });
      }
    } else{
      if (sortBy.includes('_desc')) {
        let sortData = sortBy.split('_')[0];
        this.filteredData?.sort((a: any, b: any) => {
          const levelA = a[sortData] ?? '';  // If 'level' is missing, treat as an empty string
          const levelB = b[sortData] ?? '';  // If 'level' is missing, treat as an empty string
          return levelB.localeCompare(levelA);
        });
      } else {
        let sortData = sortBy;
        this.filteredData?.sort((a: any, b: any) => {
          const levelA = a[sortData] ?? '';  // If 'level' is missing, treat as an empty string
          const levelB = b[sortData] ?? '';  // If 'level' is missing, treat as an empty string
          return levelA.localeCompare(levelB);          
        });
      }
    }
  }

  //datetime Validation
  transformDate(selectedDate: any) {
    return this.datePipe.transform((selectedDate.toISOString()), 'YYYY-MM-ddThh:mm','UTC');

  }

  closeFilter(){
    this.advanceFilter = false;
  }
  downloadLogs() {
    try {
      this.loader.show();
      this.instanceService
        .getBlobDownloadConnection(this.instanceId, this.appLogFile)
        .subscribe((resp: any) => {
          if (resp != null && resp != undefined) {
            this.blobService.downloadImageExt(
              resp.sasUrl,
              resp.container,
              resp.blob,
              async (response: any) => {
                if (response._response.status == 200) {
                  response.blobBody.then(async (onres: any) => {
                    this.response = await this.blobToString(onres);
                    let dataJson = JSON.parse(this.response);
                    
                    if(this.response) {
                      this.totaldata = dataJson.ApplicationLogResponse?.flatMap((data:any)=>{
                        return [...this.totaldata, ...data.SearchResult]
                      })

                      this.totaldata = this.totaldata.map((item:any)=>{
                        if(item?.ActivitySourceName == null || !item.hasOwnProperty('ActivitySourceName')){
                          item = {...item, 'Name': typeof(item?.Message) == 'string'? item?.Message : this.findStringMessages(item?.Message)}
                        }
                        if(!item?.Timestamp?.includes('+')){
                          item.Timestamp += '+00:00' 
                        }                        
                        if(item?.Message?.ProcessName == 'w3wp') {                          
                          item = {...item, 'Message?.ProcessName': item?.Message["log.method.filepath"]?.includes('UI') ? "UI" : "API"}
                        }
                        else if(item?.Message?.ProcessName.includes('WindowsService')){
                          item = {...item, 'Message?.ProcessName': "TaskService"}
                        }
                        return item;
                        
                      })
                      if(this.totaldata && !this.totaldata[0].hasOwnProperty('ActivitySourceName')){
                        this.displayedColumnsNewApplicationLogs = ['Level','TimeStamp', 'Action'];
                        this.levelList = ['All','Debug','Error','Warning','Critical','Verbose'];
                      }
                      this.filteredData = JSON.parse(JSON.stringify(this.totaldata));
                      try {
                        this.getNewApplicationLogs(0, 10);                       
                      } catch (e) {
                        this.loader.hide();
                        console.log(e);
                      }
                    }
                 });
                }
              }
            );
            setTimeout(() => {
              this.loader.hide();
            }, 2000);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  findStringMessages(obj:any) : any {
    // Loop through each key-value pair in the object
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        // Check if the value is a string
        if (typeof value === 'string' && (key == "Message" || key == 'Message:CallerMemberName')) {
          return value;
        } else  
        // If the value is an object, recursively search it for strings
        if (typeof value === 'object' && (key == "Message" || key == 'Message:CallerMemberName') && value !== null) {
          const result =this.findStringMessages(value);
          if (result) {
            return result;  // Return the result from the recursive call if found
          }
        }
      }
    }
    return null;
  }

  getNewApplicationLogs(pageIndex: any, pageSize: any){
    let icertisCLMLogs = this.filteredData;
      if (this.sortBy) {
      this.sortData(this.sortBy);
    }
    let startIndex = pageIndex * pageSize;
    let endIndex = startIndex + pageSize;
    this.dataSourceNewApplicationLogs = {
      matchingCount: icertisCLMLogs?.length,
      records: icertisCLMLogs.slice(startIndex, endIndex)
    }
    this.tableNewApplicationLogs = {
      reference: 'tableNewAppLogStatus',
      displayedColumns: this.displayedColumnsNewApplicationLogs,
      dataSourceValues: this.dataSourceValuesNewApplicationLogs,
      dataSource: this.dataSourceNewApplicationLogs,
      pagination: {
        required: true,
        currentPage: this.currentPageNewApplicationLogs,
        pageLength: this.pageLength,
        pageSize: this.pageSizeNewApplicationLogs
      },
    };
  }

  pageChanged(data: any) {
    let event = data.event;
    if (data.reference == 'tableNewAppLogStatus') {
      this.pageSizeNewApplicationLogs = event.pageSize;
      this.currentPageNewApplicationLogs = event.pageIndex;
      this.pageNumberNewApplicationLogs = event.pageIndex + 1;
      this.getNewApplicationLogs(
        this.currentPageNewApplicationLogs,
        this.pageSizeNewApplicationLogs
      );
    }
  }

  blobToString(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsText(blob);
    });
  }

  filterData(){
    try{
      this.filteredData = JSON.parse(JSON.stringify(this.totaldata));
      const levelFilter = this.levelData?.value;
      const sourceFilter = this.sourceData?.value;
      const searchFilter = this.inputName?.nativeElement?.value;
      if(levelFilter && levelFilter !='All'){
        this.filteredData = this.filteredData?.filter((data:any)=> data.Level == levelFilter)
      } 
      if(sourceFilter && sourceFilter !='All'){
        this.filteredData = this.filteredData?.filter((data:any)=> data["Message?.ProcessName"] == sourceFilter);
      }
      if(searchFilter && searchFilter?.replace(this.emptyFieldRegex, '').trim().length !== 0){
        this.filteredData = this.filteredData?.filter((data:any)=> data.Name?.toLowerCase().includes(searchFilter.toLowerCase()))
      }
      this.currentPageNewApplicationLogs = 0;
      this.getNewApplicationLogs(
        this.currentPageNewApplicationLogs,
        this.pageSizeNewApplicationLogs
      );
    }catch(error){
      console.log(error)
    }
  }

  clearInput(){
    if(this.inputName){
      this.inputName.nativeElement.value = '';
    }
    this.filteredData = JSON.parse(JSON.stringify(this.totaldata));
    this.currentPageNewApplicationLogs = 0;
    this.getNewApplicationLogs(this.currentPageNewApplicationLogs, this.pageSizeNewApplicationLogs)
  }

  onCancel(){
    this.location.back();
  }

  validateApplicationLogDates(elem: any) {
    this.startDateError = false;
    this.startDateErrorMsg = "";
    this.endDateError = false;
    this.endDateErrorMsg = "";

    if (elem.value == "") {
      this.validateConfirmAction = true;
      return;
    }


    var startDate = this.getStartValueappLog;
    var endDate = this.getEndValueappLog;

    let minDate = new Date();
    minDate.setDate(minDate.getDate() - 1);
    let minStartDate = minDate.toISOString().substring(0, 16);
    let minEndDate = minDate.toISOString().substring(0, 16);

    let maxStartDate = new Date().toISOString().substring(0, 16);
    let maxEndDate = new Date().toISOString().substring(0, 16);


    if (elem.id == "appStartDate" && elem.value != "") {
      if (isNaN(new Date(startDate).getTime())) {
        this.startDateError = true;
        this.startDateErrorMsg = this.instanceEnum.instance_error_InvalidStartDate;
        this.validateConfirmAction = true;
        return;
      }

      if (new Date(startDate).getTime() > new Date(maxStartDate).getTime()) {
        this.startDateError = true;
        this.startDateErrorMsg = this.instanceEnum.instance_error_startdate_less + " " + new Date(maxStartDate).toLocaleString('en-US', { hour12: true }) + " (UTC).";
        this.validateConfirmAction = true;
        return;
      }

      if(this.getStartValueappLog < this.minAppStartDate || this.getStartValueappLog > this.maxAppStartDate ){
        this.startDateError = true;
        this.startDateErrorMsg= this.instanceEnum.instance_date_error_msg +this.datePipe.transform(this.minAppStartDate,'short')+ ' and ' +this.datePipe.transform(this.maxAppStartDate,'short') + ' (UTC).';
        this.validateConfirmAction = true;
        return;
      }
    }

    if (elem.id == "appEndDate" && elem.value != "") {
      if (isNaN(new Date(endDate).getTime())) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_InvalidEndDate;
        this.validateConfirmAction = true;
        return;
      }

      if (new Date(endDate).getTime() <= new Date(startDate).getTime()) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_enddate;
        this.validateConfirmAction = true;
        return;
      }
      var daysBetweenDates = this.gethrsDifference(startDate, endDate);

      if (daysBetweenDates > 1) {
        this.endDateError = true;
        this.endDateErrorMsg = this.instanceEnum.instance_error_enddate_range;
        this.validateConfirmAction = true;
        return;
      }
    }

    if (this.getStartValueappLog != "" && this.getEndValueappLog != "") {
      if (this.startDateError == false && this.endDateError == false) this.validateConfirmAction = false;
    }
    else { this.validateConfirmAction = true; }

  }

  gethrsDifference(startDate: any, endDate: any) {
    let timeInMilisec: number = new Date(endDate).getTime() - new Date(startDate).getTime();
    let hrsBetweenDates: number = timeInMilisec / (1000 * 60 * 60);
    return hrsBetweenDates;
  }

  applicationStartDateValueChange(event: any) {
    this.setApplicationMinEndDate = this.getStartValueappLog;
    this.getEndValueappLog = '';
  }

  levelChange(event: any){
    let localData:any = localStorage.getItem('appLogFileDetails');
    this.levelData = event;
    if(localData && JSON.parse(localData).level == event?.value) {    
      this.validateConfirmAction = true;
    }
    else {
      this.validateConfirmAction = false;
    }
  }

  requestApplicationLog() {
    if(this.enableOldAppLogs) {
      this.dialogService.confirmDialog({
        title: this.instanceEnum.instance_view_application_log_requested,
        module: 'Application_Log',
        message: this.instanceEnum.instance_view_application_log_popuptext +'<b> Confirm. </b>'+ this.instanceEnum.instance_view_application_log_popuptext1,
        confirmText: 'Confirm',
        cancelText: 'Cancel'
      }).subscribe((res: any) => {
        if (res) {
          let paramreqdata = {
            "PageIndex": 1,
            "PageSize": 50,
            "startDateTime": this.getStartValueappLog,
            "endDateTime": this.getEndValueappLog,
            "filterParameters": [
              {
                "field": "SearchString",
                "value": this.getSearchValueappLog,
              }
            ],
  
          };
          this.instanceService.downloadApplicationLog(this.instanceId, paramreqdata).
            subscribe((data) => {
              this.navigateToHistory();
            },(error =>{
              this.notificationService.showNotification(error,'warning',this.instanceEnum.instance_view_application_log_header)
            })
            );
        }
      })
    } else {
    this.dialogService.confirmDialog({
      title: this.instanceEnum.instance_view_application_log_requested,
      module: 'Application_Log',
      message: this.instanceEnum.instance_view_application_log_popuptext +'<b> Confirm. </b>'+ this.instanceEnum.instance_view_application_log_popuptext1,
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    }).subscribe((res: any) => {
      if (res) {
        let paramreqdata = {
          "PageIndex": 1,
          "PageSize": 50,
          "startDateTime": this.getStartValueappLog,
          "endDateTime": this.getEndValueappLog,
          "filterParameters": [
            {
              "field": "SearchString",
              "value": this.getSearchValueappLog,
            },
            {
              "field": "TraceId",
              "value": this.getTraceId,
            },
            {
              "field": "Level",
              "value":  this.levelData?.value == 'All' ? '' : this.levelData?.value,
            },
            {
              "field": "ContextUserId",
              "value": this.getContextUserId,
            },
            {
              "field": "ContextInstanceEntityName",
              "value": this.getContextInstanceEntityName,
            },
            {
              "field": "ContextInstanceId",
              "value": this.getContextInstanceId
            },
            {
              "field": "LogType",
              "value": "0"
            }
          ],

        };
        this.instanceService.downloadApplicationLog(this.instanceId, paramreqdata).
          subscribe((data) => {
            this.navigateToHistory();
          },(error =>{
            this.notificationService.showNotification(error,'warning',this.instanceEnum.instance_view_application_log_header)
          })
        );
      }
    })
    }
  }

  navigateToHistory(){
    let json={
      path:"toolsPage",
      id:'',
      name:''
    }
    this.instanceService.sendData(JSON.stringify(json));
    this.router.navigate(['home/instanceoperations/instance-requests/history']);
  }
}
